import React from 'react';

import {CartBlack, CrossBlack} from '../components/Icons'

// This page generates no HTML, as that's all handled in the 3D scene, which is handled separately.
// all this component provides is handlers for the objectClicked events that come out of the 
// 3D scene.

export function VirtualRoom(props) {

  /*React.useEffect(() => {
    window.addEventListener('objectClicked', (event) => {

      console.log(`Virtual Room.  Object clicked event ${event.detail}`)

      switch (event.detail) {

        case 'exitDoor':
          props.updatePage(constants.REACT_PAGE_EXIT)
          break

        case 'lookClassic':
          props.updatePage(constants.REACT_PAGE_ROOM)
          props.updateRoom(constants.AFRAME_ROOM_LOOKS)
          break

        case 'lookEyes':
          props.updatePage(constants.REACT_PAGE_ROOM)
          props.updateRoom(constants.AFRAME_ROOM_LOOKS)
          break

        case 'lookLips':
          props.updatePage(constants.REACT_PAGE_ROOM)
          props.updateRoom(constants.AFRAME_ROOM_LOOKS)
          break

        case 'productLips':
          props.updatePage(constants.REACT_PAGE_ROOM)
          props.updateRoom(constants.AFRAME_ROOM_LIPS)
          break
        
        case 'tryonLips':
          props.updatePage(constants.REACT_PAGE_VTO)
          break

        default:
          console.log(`Virtual Room unexpected event ${event.detail}`)
          break
      }
    })
  })*/


  // Just show top of page icons... 
  // Also a loading screen in the background...
  return (
    <>
      <CrossBlack setAlert = {props.setAlert}/>
      <CartBlack updatePage={props.updatePage}
                 itemCount={props.itemCount}
                 cartIconStatus = {props.cartIconStatus}/>
      {/*<LookAroundPrompt/>*/}
    </>
  )
}